import * as actions from 'common/actions';

const flashMessages = (state = [], action) => {
  switch (action.type) {
    case actions.PUSH_FLASH_MESSAGE:
      return [...state, action.message];

    case actions.CLEAR_FLASH_MESSAGE:
      return state.filter(message => message.id !== action.id);

    default:
      return state;
  }
};

export default flashMessages;



// WEBPACK FOOTER //
// ./app/javascript/common/reducers/flashMessages.js